"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Label = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _utils = require("../../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Label = _styledComponents["default"].label.withConfig({
  displayName: "TextFieldstyle__Label",
  componentId: "qtxk15-0"
})(function (_ref) {
  var error = _ref.error,
      theme = _ref.theme;
  return _extends({
    display: 'flex',
    alignItems: 'center',
    color: error ? theme.color.feedback.error : theme.color.neutral['02'],
    marginBottom: theme.spacing.inline['5xs']
  }, (0, _utils.getTextStyle)({
    theme: theme,
    variant: 'body02-sm',
    margin: false
  }), {
    svg: {
      color: theme.color.feedback.success,
      height: 14
    }
  });
});

exports.Label = Label;